import { render, staticRenderFns } from "./ProductBatchStockListByProduct.vue?vue&type=template&id=62cff400"
import script from "./ProductBatchStockListByProduct.vue?vue&type=script&lang=js"
export * from "./ProductBatchStockListByProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports